export var CategoryClass;
(function (CategoryClass) {
    CategoryClass["A"] = "A";
    CategoryClass["B"] = "B";
    CategoryClass["C"] = "C";
    CategoryClass["General"] = "General";
})(CategoryClass || (CategoryClass = {}));
export var RuCategoryClassSelectValues = [
    { label: 'А', value: CategoryClass.A },
    { label: 'Б', value: CategoryClass.B },
    { label: 'В', value: CategoryClass.C },
    { label: 'General', value: CategoryClass.General },
];
